import { Component } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Membership } from "../../../business-objects/membership/membership.model";
import { isInArray } from "../../../../core/util/is-in-array";
import { Account } from "../../../business-objects/account/account.model";
import { VasAppFacade } from "../../../services/vas-app-facade.service";

interface IMultiSelectOption {
    selected: boolean;
    value: string;
    label: string;
}

class MultiSelectOption implements IMultiSelectOption {
    selected: boolean;
    value: string;
    label: string;

    constructor({selected, value, label}: IMultiSelectOption) {
        this.selected = selected;
        this.value = value;
        this.label = label;
    }
}

@Component({
    selector: "",
    templateUrl: "./membership-control-modal.component.html"
})
export class MembershipControlModalComponent {

    membership: Membership = {} as Membership;

    accessGroupOptions: Array<MultiSelectOption> = [];
    contactTypeOptions: Array<MultiSelectOption> = [];
    lookupTypesOptions: Array<MultiSelectOption> = [];
    jobTypesOptions: Array<MultiSelectOption> = [];
    jobStatusesOptions: Array<MultiSelectOption> = [];

    accessGroupsValue: Array<string> = [];
    contactTypesValue: Array<string> = [];
    lookupTypesValue: Array<string> = [];
    jobTypesValue: Array<string> = [];
    jobStatusesValue: Array<string> = [];
    admin: boolean;

    constructor(
        protected params: NavParams,
        protected viewCtrl: ViewController,
        protected appFacade: VasAppFacade
    ) {

        const p = this.viewCtrl.getNavParams();
        const userId = p.get("userId");

        if (!userId) {
            console.warn("userId is not an instance of string");
            return;
        }

        Observable.zip(
            this.appFacade.objects.membership.store.getAll(),
            this.appFacade.objects.account.store.getActive()
        )
            .map(args => {
                let memberships: Array<Membership>;
                let account: Account;

                [memberships, account] = args;

                return memberships
                    .filter(m => m.user === userId && m.account === account.id)
                    .pop();
            })
            .take(1)
            .subscribe(
                membership => {

                    if (!membership) {
                        // @todo warn user. dismiss
                        return;
                    }

                    this.membership = membership;
                    this.initialiseAccessGroup(membership);
                    this.initialiseContactTypes(membership);
                    this.initialiseLookupTypes(membership);
                    this.initialiseJobTypes(membership);
                    this.initialiseJobStatuses(membership);
                    this.admin = membership.admin;
                }
            );
    }

    initialiseAccessGroup(membership: Membership): void {

        this.appFacade.objects.accessGroup.store
            .getAll()
            .map(items => this.getOptions(items, membership, "accessGroups"))
            .take(1)
            .subscribe(options => {
                this.accessGroupOptions = options;
                this.accessGroupsValue = this.accessGroupOptions
                    .filter(option => option.selected)
                    .map(option => option.value);
            });
    }

    initialiseContactTypes(membership: Membership): void {

        this.appFacade.objects.controlType.store
            .getAll()
            .map(items => this.getOptions(items, membership, "contactTypes"))
            .take(1)
            .subscribe(options => {
                this.contactTypeOptions = options;
                this.contactTypesValue = this.contactTypeOptions
                    .filter(option => option.selected)
                    .map(option => option.value);
            });
    }

    initialiseLookupTypes(membership: Membership): void {

        this.appFacade.objects.lookupType.store
            .getAll()
            .map(items => this.getOptions(items, membership, "lookupTypes"))
            .take(1)
            .subscribe(options => {
                this.lookupTypesOptions = options;
                this.lookupTypesValue = this.lookupTypesOptions
                    .filter(option => option.selected)
                    .map(option => option.value);
            });
    }

    initialiseJobTypes(membership: Membership): void {

        this.appFacade.objects.jobType.store
            .getAll()
            .map(items => this.getOptions(items, membership, "jobTypes"))
            .take(1)
            .subscribe(options => {
                this.jobTypesOptions = options;
                this.jobTypesValue = this.jobTypesOptions
                    .filter(option => option.selected)
                    .map(option => option.value);
            });
    }

    initialiseJobStatuses(membership: Membership): void {

        this.appFacade.objects.jobStatus.store
            .getAll()
            .map(items => this.getOptions(items, membership, "jobStatuses"))
            .take(1)
            .subscribe(options => {
                this.jobStatusesOptions = options;
                this.jobStatusesValue = this.jobStatusesOptions
                    .filter(option => option.selected)
                    .map(option => option.value);
            });
    }

    getOptions(items, membership: Membership, membershipProperty: string): Array<MultiSelectOption> {
        return items.map(item => {
            return new MultiSelectOption({
                    selected: isInArray(item.id, membership[membershipProperty]),
                    value: item.id,
                    label: item.title
                }
            );
        });
    }

    dismiss(params?): void {
        this.viewCtrl.dismiss(params);
    }

    onSubmit(): void {
        this.dismiss({
            ...this.membership,
            accessGroups: this.accessGroupsValue,
            contactTypes: this.contactTypesValue,
            lookupTypes: this.lookupTypesValue,
            jobTypes: this.jobTypesValue,
            jobStatuses: this.jobStatusesValue,
            admin: this.admin
        });
    }

    onCancel(): void {
        this.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/membership/form/membership-control-modal.component.ts